import { Link } from "react-router-dom";

const quickLinks = [
  { label: "动漫资讯", to: "/news" },
  { label: "动漫作品", to: "/works" },
  { label: "综合搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

const friendlyLinks = [
  { label: "新番导视", to: "/news" },
  { label: "作品库", to: "/works" },
  { label: "治愈日常合集", to: "/works" },
  { label: "反馈留言", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-leaf-fill text-lg"></i>
              </span>
              <span className="font-logo text-2xl text-background-50 leading-none pt-1">
                漫蛙官网
              </span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed max-w-md">
              漫蛙官网是面向动漫爱好者的内容门户，聚合最新动漫资讯与多样作品展示，
              帮助你在第一时间掌握动漫动态，也方便按类型与主题探索心仪的作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-youtube-fill"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="w-9 h-9 rounded-full bg-primary-800 text-background-100 flex items-center justify-center hover:bg-primary-700 cursor-pointer transition-colors"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </span>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">友情链接</h4>
            <ul className="space-y-3">
              {friendlyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-10 pt-6 border-t border-primary-800">
          <p className="text-xs text-background-300">
            本站内容为演示用途，资讯与作品均为虚构示例。
          </p>
          <p className="text-xs text-background-300">
            © 2026 漫蛙官网 Manwa. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}